(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/star-confetti.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/star-confetti.js');
"use strict";

const normalizedFps = 144; 
const starsPerCanon = 15;
const numberOfCanons = 9;
const canonInterval = 450;
const starSize = 15;
const imgPath = "".concat(svs.core.config.data.svsconfig.cdn, "/images/ticketgames/ticket-utility/stars.png");
let ctx;
let canvas;
let isRunning = false;
let particles = [];
let ticks = 0;
let uniqueId = 0;
let avgFps = 0;
let frames = [];
let optimized = false;
let isLeft = true;
let lastFrameTime = performance.now();
let delta = 0;
let image;
const framesBig = [{
  x: 1,
  y: 1,
  w: 446,
  h: 414
}, {
  x: 449,
  y: 1,
  w: 367,
  h: 357
}, {
  x: 818,
  y: 1,
  w: 373,
  h: 325
}];
const framesSmall = [{
  x: 1193,
  y: 1,
  w: 53,
  h: 53
}, {
  x: 1248,
  y: 1,
  w: 73,
  h: 74
}, {
  x: 1323,
  y: 1,
  w: 50,
  h: 51
}, {
  x: 1375,
  y: 1,
  w: 50,
  h: 51
}, {
  x: 1427,
  y: 1,
  w: 94,
  h: 96
}, {
  x: 1523,
  y: 1,
  w: 77,
  h: 81
}, {
  x: 1602,
  y: 1,
  w: 69,
  h: 73
}, {
  x: 1673,
  y: 1,
  w: 94,
  h: 95
}];
async function init() {
  if (isRunning) {
    cleanup();
  }
  canvas = document.createElement('canvas');
  canvas.style.position = 'fixed';
  canvas.style.top = 0;
  canvas.style.left = 0;
  canvas.style.pointerEvents = 'none';
  canvas.style.zIndex = 1000;
  ctx = canvas.getContext('2d');
  document.body.appendChild(canvas);
  window.addEventListener('resize', setCanvasSize);
  setCanvasSize();
  isRunning = true;
  await setup();
  requestAnimationFrame(spawnCannon);
  requestAnimationFrame(tick);
}
function cleanup() {
  isRunning = false;
  frames = [];
  particles = [];
  canvas.remove();
}
function setCanvasSize() {
  const canvas = ctx.canvas;
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  ctx.width = canvas.width;
  ctx.height = canvas.height;
}
class Particle {
  constructor(_ref) {
    let {
      x,
      y,
      w,
      h,
      velocity,
      id,
      frames,
      rotationVelocity
    } = _ref;
    this.id = id;
    this.x = x;
    this.y = y;
    this.w = w;
    this.h = h;
    this.alpha = 1;
    this.frames = frames;
    this.imgIndex = Math.floor(Math.random() * this.frames.length);
    this.velocity = velocity;
    this.rotation = Math.random() * Math.PI * 2;
    this.rotationVelocity = rotationVelocity;
  }
  draw() {
    const {
      x,
      y,
      w,
      h
    } = this.frames[this.imgIndex];
    if (!optimized) {
      ctx.shadowColor = 'rgba(0, 0, 0, 0.7)';
      ctx.shadowBlur = 5; 
      ctx.shadowOffsetX = 5; 
      ctx.shadowOffsetY = 5; 
    } else {
      ctx.shadowColor = 'rgba(255, 255, 255, 0)';
      ctx.shadowBlur = 0;
    }
    ctx.save();
    ctx.translate(this.x + this.w / 2, this.y + this.h / 2);
    ctx.rotate(this.rotation);
    ctx.drawImage(image, x, y, w, h, -this.w / 2, -this.h / 2, this.w, this.h);
    ctx.restore();
  }
  update() {
    if (this.checkBounds()) {
      particles = particles.filter(p => p.id !== this.id);
      if (particles.length === 0) {
        isRunning = false;
      }
      return;
    }

    if (ticks % 15 === 0) {
      this.imgIndex = (this.imgIndex + 1) % this.frames.length;
    }
    const [xVelocity, yVelocity] = this.velocity;
    this.x += xVelocity * (delta * normalizedFps);
    this.y += yVelocity * (delta * normalizedFps);
    this.rotation += this.rotationVelocity * (delta * normalizedFps);
    this.velocity[1] += 0.01 * (delta * normalizedFps);
    this.velocity[0] *= 0.997;
  }
  checkBounds() {
    const leftBound = -ctx.width / 2;
    const rightBound = ctx.width + ctx.width / 2;
    const topBound = -ctx.height * 2;
    const bottomBound = ctx.height + ctx.height / 2;
    return this.x < leftBound || this.x > rightBound || this.y > bottomBound || this.y < topBound;
  }
}
function spawnCannon() {
  let x;
  let y;
  let velocity;
  const widthFactor = ctx.width / 1000;
  const heightFactor = ctx.height / 1000;
  let index = 0;
  const interval = setInterval(() => {
    y = ctx.height - index * (ctx.height / 12);
    if (isLeft) {
      x = 0;
    } else {
      x = ctx.width;
    }
    for (let i = 0; i < starsPerCanon; i++) {
      const w = Math.random() * starSize + starSize;
      const h = w;
      if (isLeft) {
        velocity = [Math.random() * 5 * widthFactor, Math.random() * -10 * heightFactor];
      } else {
        velocity = [Math.random() * -5 * widthFactor, Math.random() * -10 * heightFactor];
      }
      const id = uniqueId++;
      const isLarge = Math.random() > 0.5;
      const frames = isLarge ? framesBig : framesSmall;
      const rotationVelocity = isLarge ? 0 : Math.random() / 100 - 0.005;
      const particle = new Particle({
        x: x - w / 2,
        y: y - h / 2,
        w,
        h,
        velocity,
        id,
        frames,
        rotationVelocity
      });
      particles.push(particle);
    }
    index++;
    if (index === numberOfCanons) {
      clearInterval(interval);
    }
    isLeft = !isLeft;
  }, canonInterval);
}
async function setup() {
  lastFrameTime = performance.now();
  image = new Image();
  image.src = imgPath;
  await new Promise((resolve, reject) => {
    image.onload = resolve;
    image.onerror = reject;
  });
  optimized = false;
}
function tick() {
  if (!isRunning) {
    cleanup();
    return;
  }
  ticks++;
  if (!optimized) {
    frames.push(performance.now());
    if (frames.length > 100) {
      frames.shift();
    }
    avgFps = 1000 / ((frames[frames.length - 1] - frames[0]) / 100);
    if (avgFps < 45 && frames.length >= 100) {
      optimized = true;
    }
  }
  delta = (performance.now() - lastFrameTime) / 1000;
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  particles.forEach(particle => {
    particle.update();
    particle.draw();
  });
  lastFrameTime = performance.now();
  requestAnimationFrame(tick);
}
setGlobal('svs.ticketUtility.utils.starConfetti', init);

 })(window);